import { Fragment, FunctionComponent } from "react";
import AnchorProps from "./AnchorProps.interface";

import { Link, useHistory, useLocation } from "react-router-dom";
import getRelativeUrl from "helpers/getRelativeUrl";
import isBrowserContext from "helpers/isBrowserContext";
import React from "react";
import urlBuilder from "app/umbraco/helpers/urlBuilder";
import { HashLink } from "react-router-hash-link";

const Anchor: FunctionComponent<AnchorProps> = (props): JSX.Element => {
  const location = useLocation<any>();
  const history = useHistory();

  let result = "";

  // Internal / External
  if (props.to && typeof props.to === "string") {
    result = getRelativeUrl(props.to);
  }
  // Hash
  else if (props.to && Array.isArray(props.to) && props.to?.[0]?.url) {
    result = getRelativeUrl(props.to?.[0]?.url);
  }
  // Media
  else if (props.to && Array.isArray(props.to)) {
    result = urlBuilder(props.to?.[0]?.url).toString();
  }

  if (!result) {
    return (
      <div className={props.className} onClick={props.onClick}>
        {props.children}
      </div>
    );
  }

  const isExternalLevel1 = props?.linkType === "externalMenuLink";
  const isExternalLevel2 = props?.linkType === "externalMenuLink2";

  const onAnchorClick = (event: any) => {
    updateScrollYState();

    if (typeof props.onClick !== "undefined") {
      props.onClick(event);
    }
  };

  // #SCROLL_RESTORATION: Saving scrollbar position before page changes
  const updateScrollYState = () => {
    if (isBrowserContext()) {
      history.replace({
        pathname: location.pathname,
        state: {
          ...location.state,
          scrollY: window.scrollY,
        },
      });
    }
  };

  return (
    <Fragment>
      {/* Hash */}
      {!result.startsWith("http") && result.indexOf("#") > 0 ? (
        <HashLink
          smooth
          to={result}
          style={props.style}
          id={props.id}
          title={props.title}
          className={props.className}
        >
          {props.children}
        </HashLink>
      ) : null}

      {/* External with Hash */}
      {result.startsWith("http") && result.indexOf("#") > 0 ? (
        <a
          href={result}
          style={props.style}
          id={props.id}
          title={props.title}
          className={props.className}
          rel="noreferrer noopener"
          target="_blank"
        >
          {props.children}
        </a>
      ) : null}

      {/* External */}
      {result.startsWith("http") && result.indexOf("#") === -1 ? (
        <a
          href={result}
          style={props.style}
          id={props.id}
          title={props.title}
          className={props.className}
          rel="noreferrer noopener"
          target={isExternalLevel1 || isExternalLevel2 ? "_blank" : "_self"}
        >
          {props.children}
        </a>
      ) : null}

      {/* Internal */}
      {result.startsWith("/") &&
      !result.startsWith("/media") &&
      result.indexOf("#") === -1 ? (
        <Link
          to={result}
          style={props.style}
          id={props.id}
          title={props.title}
          className={props.className}
          onClick={(event: any) => onAnchorClick(event)}
        >
          {props.children}
        </Link>
      ) : null}

      {/* Media */}
      {result.startsWith("/media") ? (
        <a
          href={result}
          style={props.style}
          id={props.id}
          title={props.title}
          className={props.className}
          rel="noreferrer noopener"
          target="_blank"
        >
          {props.children}
        </a>
      ) : null}
    </Fragment>
  );
};

export default Anchor;
